module.exports = __webpack_public_path__ + "img/about_kg.513e5451.png";